import { AppRuntimeConfig } from '../models/app-runtime-config.model';

export const DEFAULT_APP_CONFIG: AppRuntimeConfig = {
  schemaVersion: 1,
  tenant: 'default',

  application: {
    title: 'Mi aplicación',
    language: 'es',
    ariaLabel: 'Aplicación'
  },

  layout: {
    showNavigation: true
  },

  features: {
    showHeader: true,
    showFooter: true,
    showHelpButton: false,
    showPromotionalBanner: false,
    showDownloadButton: false,
    showContactSection: false,
    showMarketPlaceHeader: true,
    showCategoryFinder: true
  },

  theme: {
    colors: {
      primary: '#08478E',
      onPrimary: '#FFFFFF',
      secondary: '#0E6EB6',
      onSecondary: '#FFFFFF',
      tertiary: '#00CC99',
      onTertiary: '#FFFFFF',
      background: '#F5F7FA',
      surface: '#FFFFFF',
      text: '#1A1A1A',
      mutedText: '#666666',
      border: '#D9DEE7',
      success: '#198754',
      warning: '#FFC107',
      danger: '#DC3545',
      labelBlue: '#0D6DB5',
      labelOrange: '#F39734',
      marketPlaceBackground: '#F5F7FA'
    },

    typography: {
      fontFamily: 'Arial, sans-serif',
      headingFontFamily: 'Arial, sans-serif',
      baseFontSize: '16px',
      headingFontWeight: 700
    },

    radius: {
      small: '4px',
      medium: '8px',
      large: '16px',
      pill: '999px'
    },

    spacing: {
      small: '8px',
      medium: '16px',
      large: '24px'
    }
  },

  assets: {
    logos: {
      primary: '/brands/default/logos/logo.svg',
      compact: '/brands/default/logos/logo-compact.svg',
      footer: '/brands/default/logos/logo.svg'
    },

    favicon: '/brands/default/favicon.ico',

    icons: {
      menu: '/brands/default/icons/menu.svg',
      close: '/brands/default/icons/close.svg',
      home: '/brands/default/icons/home.svg',
      help: '/brands/default/icons/help.svg',
      success: '/brands/default/icons/success.svg',
      warning: '/brands/default/icons/warning.svg',
      error: '/brands/default/icons/error.svg',
      download: '/brands/default/icons/download.svg'
    },

    // Vacío a propósito: cada tenant define sus propias entidades de negocio en su JSON.
    entityIcons: {}
  }
};
